import { Injectable, OnDestroy, OnInit } from "@angular/core";
import * as moment from "moment";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { User } from "projects/sepidz-web-framework/src/lib/models";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { Subject, Subscription } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { DepositChangedFieldEnum, DepositChanges, DepositModel } from "../../catalog/model/deposit.model";
import { LocalSettingService } from "../../local-setting/local-setting.service";
import { CreditControlType, Customer } from "../../parties/model/customer.model";
import { PrintPolicyPrintTimeEnum } from "../../prints/model/print-policy.model";
import { DeliveryCustomerPrintTime, SaleMethodNature } from "../../sales/model/sale-method-branch.model";
import { ActivePageEnum } from "../model/activepage.enum";
import { FastAccessEnum } from "../model/fastaccessenum";
import {
  Invoice,
  InvoiceChanges,
  InvoiceChangesLookup,
  InvoiceCommand,
  InvoiceMode,
  InvoicePayableChange,
  InvoicePrintLocal,
  InvoiceStatus,
} from "../model/invoice.model";
import { PaymentMethodEnum } from "../model/paymentmethod.enum";
import { ReceiptPaymentModel, ReceiptPaymentTypeEnum } from "../model/receiptpayment.model";
import { OrderService } from "../order.service";
import { PaymentComponent } from "../orderpage/invoice/payment/payment.component";
import { PreparationDeliveryTimeFormComponent } from "../orderpage/invoice/preparation-delivery-time-form/preparation-delivery-time-form.component";
import { InvoicePrintService } from "./invoiceprint.service";
import { TabletPosService } from "./tabletpos.service";
import { PaymentMethodType } from "../../financial/model/payment-method.enum";
@Injectable({
  providedIn: "root",
})
export class InvoiceActionService extends BaseService implements OnInit, OnDestroy {
  public order: OrderService;
  public openFromPaymentForm: boolean;
  public invoicePrint: InvoicePrintService;
  private invoice: Invoice;
  public posPaymentInvoice: Invoice;
  public saveEnd: Subject<any> = new Subject<any>();
  public ActionFinish: Subject<any> = new Subject<any>();
  public saveEndSubscription: Subscription | null = null;
  invoiceCommand: typeof InvoiceCommand = InvoiceCommand;
  public isStartAction: number = 0;
  paymentModalIsOpened: boolean;
  constructor(
    private localSettingService: LocalSettingService,
    public tabletPos: TabletPosService,
    public invoicePrintService: InvoicePrintService,
    private common: CommonService
  ) {
    super();
    if (this.order) this.localSettingService.tabsservice = this.order.tabsservice;
    this.ngOnInit();
  }
  ngOnDestroy() {
    this.saveEnd.unsubscribe();
    this.ActionFinish.unsubscribe();
  }
  ngOnInit() {
    this.accountService.authService.hasLocalSetting().pipe(take(1)).subscribe();
  }

  SaveInvoice(Action: InvoiceCommand, invoice: Invoice, NonValidation?: boolean, order?: OrderService, PrintPolicyId?: number) {
    if (order) {
      this.order = null;
      this.order = order;
    }
    if (Action === InvoiceCommand.CustomerTabletPrint && invoice.CustomerPrintCount == 0) {
      invoice.CustomerPrintCount++;
    }
    if (Action == InvoiceCommand.PreparationPrint && this.order.saleMethodBranch.PreprationTimeRequired && !invoice.PreprationDeliveryTime) {
      this.dialogService
        .open(PreparationDeliveryTimeFormComponent, { label: this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.DeliveryTime") })
        .pipe(take(1))
        .subscribe((preparationDeliveryTime) => {
          if (preparationDeliveryTime) {
            invoice.PreprationDeliveryTime = preparationDeliveryTime;
            this.SetInvoice(Action, invoice, NonValidation, this.order, PrintPolicyId);
          } else {
            this.isStartAction = 0;
            this.ActionFinish.next(true);
            this.sts.showToast(
              "danger",
              this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Error"),
              `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.SelectDeliveryTime")}`
            );
          }
        });
    } else this.SetInvoice(Action, invoice, NonValidation, this.order, PrintPolicyId);
  }
  SetInvoice(Action: InvoiceCommand, invoice: Invoice, NonValidation?: boolean, order?: OrderService, PrintPolicyId?: number) {
    invoice.ComputerName = this.storage.getData(ClearableCache.ComputerName);
    this.isStartAction++;
    if (!invoice.FiscalYearId) {
      if (this.accountService.authService.currentFiscalYear) invoice.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      else
        this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
          if (x) invoice.FiscalYearId = x.Id;
        });
    }
    if (PrintPolicyId) {
      invoice.PrintPolicyId = PrintPolicyId;
    }
    if (!invoice.Credit) invoice.Credit = 0;
    this.invoice = JSON.parse(JSON.stringify(invoice));
    if (!NonValidation && !this.isValid(this.invoice, Action)) {
      this.isStartAction = 0;
      this.ActionFinish.next(true);
      return;
    }
    if (this.order.invoice.isDebit && this.order.invoice.Debit === this.order.invoice.PayableTotal) {
      this.invoice.HasPaymentLink = false;
      this.invoice.HasFactorLink = false;
    }

    if (this.order.invoice.DescCustomer || this.order.invoice.DescKitchen) {
      const description = `${this.order.invoice.DescKitchen}///${this.order.invoice.DescCustomer}///`;
      this.invoice.Description = description;
    }
    const hasDeposit = this.accountService.authService?.currentInformation()?.OrderServices && this.order.saleMethodBranch.HasDeposit;
    // Deposit Validation
    if (
      hasDeposit &&
      Action !== InvoiceCommand.ReprintForPreparation &&
      Action !== InvoiceCommand.ReprintForCustomer &&
      Action !== InvoiceCommand.Cancel &&
      !NonValidation
    ) {
      let deposit = this.order.depositFormGroup.value;
      if (this.order.invoice.OldSaleMethodBranchId != null && !deposit.Id) {
        deposit.InvoiceId = this.invoice.Id;
        deposit.State = RowState.New;
      } else if (deposit.Id && this.order.depositFormGroup.dirty) {
        deposit.State = RowState.Modify;
      }
      this.setDepositChanges(deposit);
      this.invoice.Deposit = deposit;
      const originalDate = this.invoice.Deposit.ServingFoodDate;
      const newTime = this.invoice.Deposit.ServingFoodTime;
      if (newTime && originalDate) {
        const [newHours, newMinutes] = newTime.split(":");
        originalDate.setHours(parseInt(newHours, 10));
        originalDate.setMinutes(parseInt(newMinutes, 10));
      }
      const depositValidation = this.order.depositValidation();
      if (depositValidation.errMessage) {
        this.sts.showDialog(
          depositValidation.errMessage,
          this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
          null,
          () => {
            if (depositValidation.focusOnServicesAmount) this.focus("ServicesAmount");
          }
        );
        this.isStartAction = 0;
        this.ActionFinish.next(true);
        return;
      } else if (!this.paymentModalIsOpened) {
        if (Action === InvoiceCommand.PreparationPrint && !this.order.isLight && !this.order.stockDialogIsOpened) {
          const notStockList = this.getNotStockList(invoice);
          if (notStockList.length) {
            this.sts.showDialog(
              `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.FollowingProductsUnavailable")}: <br/>
              ${notStockList.join(" <br/> ")}
              `,
              this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.OutOfStock"),
              DialogType.confirm,
              () => {
                this.order.stockDialogIsOpened = false;
                this.paymentModalIsOpened = true;
                this.dialogService
                  .open(
                    PaymentComponent,
                    { order: this.order, invoiceAction: this, group: null, isDeposit: true, action: Action },
                    { closeOnClickOutside: false }
                  )
                  .pipe(take(1))
                  .subscribe((res) => {
                    if (!res) {
                      this.isStartAction = 0;
                      this.ActionFinish.next(true);
                    }
                    this.paymentModalIsOpened = false;
                  });
              },
              () => {
                this.order.stockDialogIsOpened = false;
                this.isStartAction = 0;
                this.ActionFinish.next(true);
              }
            );
            this.order.stockDialogIsOpened = true;
          } else {
            this.paymentModalIsOpened = true;
            this.dialogService
              .open(
                PaymentComponent,
                { order: this.order, invoiceAction: this, group: null, isDeposit: true, action: Action },
                { closeOnClickOutside: false }
              )
              .pipe(take(1))
              .subscribe((res) => {
                if (!res) {
                  this.isStartAction = 0;
                  this.ActionFinish.next(true);
                }
                this.paymentModalIsOpened = false;
              });
          }
        } else {
          this.paymentModalIsOpened = true;
          this.dialogService
            .open(
              PaymentComponent,
              { order: this.order, invoiceAction: this, group: null, isDeposit: true, action: Action },
              { closeOnClickOutside: false }
            )
            .pipe(take(1))
            .subscribe((res) => {
              if (!res) {
                this.isStartAction = 0;
                this.ActionFinish.next(true);
              }
              this.paymentModalIsOpened = false;
            });
        }
        return;
      }
    } else if ((!hasDeposit || Action === InvoiceCommand.PreparationPrint) && !this.order.isLight && !this.order.stockDialogIsOpened) {
      const notStockList = this.getNotStockList(invoice);
      if (notStockList.length) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.FollowingProductsUnavailable")}: <br/>
          ${notStockList.join(" <br/> ")}
          `,
          this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.OutOfStock"),
          DialogType.confirm,
          () => {
            this.order.stockDialogIsOpened = false;
            this.beforeUpdate(Action, invoice);
            this.saveOrCheckRemain(invoice);
          },
          () => {
            this.order.stockDialogIsOpened = false;
            this.isStartAction = 0;
            this.ActionFinish.next(true);
          }
        );
        this.order.stockDialogIsOpened = true;
        return false;
      }
    }
    this.beforeUpdate(Action, invoice);
    this.saveOrCheckRemain(invoice);
  }

  saveOrCheckRemain(invoice: Invoice): void {
    if (
      (this.invoice.Customer.CreditLimit <= 0 &&
        (!this.invoice?.Customer?.HasCredit || this.invoice?.Customer?.CreditLimit <= 0 || !this.invoice?.Customer?.CreditLimit) &&
        this.invoice.Debit <= 0) ||
      this.invoice.CommandCode === InvoiceCommand.ReprintForCustomer ||
      this.invoice.CommandCode === InvoiceCommand.ReprintForPreparation ||
      this.invoice.CommandCode === InvoiceCommand.Delete ||
      this.invoice.CommandCode === InvoiceCommand.CustomerA5Print ||
      this.invoice.CommandCode === InvoiceCommand.CustomerFinancialA5Print ||
      this.invoice.CommandCode === InvoiceCommand.CustomerFinancialPrint ||
      this.invoice.CommandCode === InvoiceCommand.Assign ||
      this.invoice.CommandCode === InvoiceCommand.CustomerTabletPrint ||
      this.order.saleMethodBranch.HasDeposit
    ) {
      invoice.Id ? this.UpdateInvoice() : this.InsertInvoice();
    } else {
      this.checkRemainCredit();
    }
  }

  beforeUpdate(Action: InvoiceCommand, invoice: Invoice): void {
    switch (Action) {
      case InvoiceCommand.Save:
        this.BeforUpdateInvoice(invoice.StatusCode, InvoiceCommand.Save);
        break;
      case InvoiceCommand.TemporaryRegister:
        this.BeforUpdateInvoice(InvoiceStatus.Pending, InvoiceCommand.TemporaryRegister);
        break;
      case InvoiceCommand.PreparationPrint:
        this.BeforUpdateInvoice(InvoiceStatus.Ordering, InvoiceCommand.PreparationPrint);
        break;
      case InvoiceCommand.CustomerPrint:
        this.BeforUpdateInvoice(InvoiceStatus.Clearing, InvoiceCommand.CustomerPrint);
        break;
      case InvoiceCommand.CustomerTabletPrint:
        this.BeforUpdateInvoice(InvoiceStatus.Clearing, InvoiceCommand.CustomerTabletPrint);
        break;
      case InvoiceCommand.Print:
        this.BeforUpdateInvoice(InvoiceStatus.Clearing, InvoiceCommand.Print);
        break;
      case InvoiceCommand.ClearWithoutPrint:
        this.BeforUpdateInvoice(InvoiceStatus.Cleared, InvoiceCommand.ClearWithoutPrint);
        break;
      case InvoiceCommand.Clear:
        this.BeforUpdateInvoice(InvoiceStatus.Cleared, InvoiceCommand.Clear);
        break;
      case InvoiceCommand.Cancel:
        this.BeforUpdateInvoice(InvoiceStatus.Cancelled, InvoiceCommand.Cancel);
        break;
      case InvoiceCommand.PosPayment:
        this.BeforUpdateInvoice(InvoiceStatus.Ordering, InvoiceCommand.PosPayment);
        break;
      case InvoiceCommand.TabletPos:
        this.BeforUpdateInvoice(InvoiceStatus.Ordering, InvoiceCommand.TabletPos);
        break;
      case InvoiceCommand.CustomerFinancialPrint:
        this.BeforUpdateInvoice(InvoiceStatus.Clearing, InvoiceCommand.CustomerFinancialPrint);
        break;
      case InvoiceCommand.CustomerA5Print:
        this.BeforUpdateInvoice(InvoiceStatus.Clearing, InvoiceCommand.CustomerA5Print);
        break;
      case InvoiceCommand.CustomerFinancialA5Print:
        this.BeforUpdateInvoice(InvoiceStatus.Clearing, InvoiceCommand.CustomerFinancialA5Print);
        break;
      default:
        this.BeforUpdateInvoice(invoice.StatusCode, invoice.CommandCode);
        break;
    }
  }

  //اعتبار سنجی فاکتور
  isValid(invoice: Invoice, Action?: InvoiceCommand): boolean {
    if (this.order.isMultiBranch && this.order.Branches.length > 1) {
      if (this.order.currentSaleMethodNature !== this.order.SaleMethodNature.Delivery) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.NotPossiblePlaceOrderBranch")}`,
          this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage")
        );
        return false;
      } else if (invoice.BranchId === this.order.logInBranch.Id) {
        return false;
      }
    }
    const isActiveCategory = this.order.customerInActiveCategory(invoice?.AddressId, invoice?.Customer, invoice?.BranchId);
    if (isActiveCategory) {
      this.order.sts?.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.OrderSelectedCustomerGroupBranch")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage")
      );
      return;
    }
    if (!invoice.CustomerId || invoice.CustomerId === 0) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.EnteringCustomerMandatory")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage")
      );
      return false;
    } else if (!invoice.Items) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.SelectingLeastOneItemMandatory")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage")
      );
      return false;
    } else if (!invoice.BranchId) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.BranchSelectionMandatory")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage")
      );
      return false;
    } else if (!invoice.SaleMethodBranchId) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.MethodSaleInvalid")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage")
      );
      return false;
    }
    const BranchId = invoice.CustomerAddress?.DefaultBranchId || invoice.CustomerAddress?.Zone?.Branches?.find((x) => x.IsDefault)?.BranchId;
    if (Action && this.order.isMultiBranch && BranchId && BranchId !== invoice.BranchId) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.SelectedCustomerDefaultBranch")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
        DialogType.confirm,
        () => {
          this.beforeUpdate(Action, invoice);
          this.saveOrCheckRemain(invoice);
        }
      );
      return false;
    }
    invoice.NumberOfGuests = this.order.formGroup.controls["NumberOfGuests"].value;
    if (this.order.saleMethodBranch.NumberOfGuestsIsRequired && (!invoice.NumberOfGuests || invoice.NumberOfGuests <= 0)) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.EnteringNumberOfPeopleMandatory")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
        DialogType.alert,
        () => {
          this.order.showHeader = true;
          this.focus("NumberOfGuests");
        }
      );
      return false;
    }
    if (this.order.saleMethodBranch.TableIsRequired && (!invoice.TableId || invoice.TableId === 0)) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.EnteringTableMandatory")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
        DialogType.alert,
        () => this.openFastAccess(FastAccessEnum.Salon)
      );
      this.order.hideFastAccess = true;
      return false;
    }
    if (this.order.saleMethodBranch.WaiterIsRequired && (!invoice.WaiterId || invoice.WaiterId === 0)) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.EnteringHostMandatory")}`,
        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
        DialogType.alert,
        () => this.openFastAccess(FastAccessEnum.Waiter)
      );
      this.order.hideFastAccess = true;
      return false;
    }
    if (
      (invoice.HasFactorLink || invoice.HasPaymentLink) &&
      invoice.Customer?.Number !== 0 &&
      !this.common.smartConnection &&
      invoice.SaleMethodBranch?.PrintForOnlineOrderForNewCustomer
    ) {
      const inputDate = new Date(invoice.Customer.CreatedDate);
      const todaysDate = new Date();
      if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
        this.sts.showDialog(
          `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ConnectionPaymentLinkServiceDisconnected")}`,
          this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
          DialogType.alert
        );
        return false;
      }
    }
    return true;
  }
  getNotStockList(invoice: Invoice): string[] {
    const currentBranch = this.order.Branches.find((x) => x.Id === invoice.BranchId) || this.order.logInBranch;
    const notStockList: { goodsTitle: string; itemTitle: string; neededAmount: number }[] = [];
    invoice.Items.forEach((i) => {
      const goodsStockInfo = this.order.warehouseStockItems.find(
        (x) =>
          (x.PrevRemainAmount || x.EntryAmount) &&
          x.BranchId === currentBranch.Id &&
          (x.ItemsInRelation.some((x) => x.Id === i.ItemId) || x.GoodsId === i.GoodsId)
      );

      const goodsFormulaQty =
        (goodsStockInfo?.ItemsInRelation?.some((x) => x.Id === i.ItemId)
          ? goodsStockInfo?.ItemsInRelation.find((x) => x.Id === i.ItemId).DecreaseAmount
          : goodsStockInfo?.DecreaseAmount) ?? 0;

      if (goodsStockInfo?.Amount < i.Quantity * goodsFormulaQty)
        notStockList.push({
          goodsTitle: goodsStockInfo.GoodsTitle,
          itemTitle: i.ItemTitle,
          neededAmount: goodsStockInfo?.Amount - i.Quantity * goodsFormulaQty,
        });
    });
    if (notStockList.length) {
      return notStockList.map(
        (x) =>
          "(" +
          x.goodsTitle +
          " - " +
          x.itemTitle +
          " - " +
          this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Number") +
          x.neededAmount +
          ")"
      );
    } else return [];
  }
  //تنظیمات قبل از ویرایش فاکتور
  BeforUpdateInvoice(statusCode: number, commandCode: number) {
    this.SetInvoiceDefaults();
    if (this.invoice.Id) {
      this.SetInvoiceChanges();
      if (
        statusCode === InvoiceStatus.Cancelled ||
        (this.invoice.OriginalValue?.StatusCode !== InvoiceStatus.Cleared &&
          statusCode === InvoiceStatus.Cleared &&
          this.invoice.CommandCode != InvoiceCommand.ReprintForCustomer &&
          this.invoice.CommandCode != InvoiceCommand.ReprintForPreparation)
      ) {
        this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
      }
    } else this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;

    this.SetInvoiceStatuses(statusCode, commandCode, this.invoice.Id ? InvoiceMode.Update : InvoiceMode.Insert);
    if (
      (this.invoice.StatusCode === InvoiceStatus.Cleared ||
        this.invoice.CommandCode === InvoiceCommand.PosPayment ||
        this.invoice.CommandCode === InvoiceCommand.TabletPos) &&
      this.invoice.ReceiptPayments?.length <= 0
    ) {
      this.invoice.ReceiptPayments = [];
      this.addCashReceiptPayment();
    }
    const DefaultPaymentId = this.order.saleMethodBranch?.PaymentMethods?.find((s) => s.IsDefault)?.PaymentMethodId;

    if (DefaultPaymentId && !this.openFromPaymentForm) {
      this.invoice?.ReceiptPayments?.forEach((x) => {
        x.ReceiptPaymentTypeCode = this.order.receiptPaymentTypeLookup.find((f) => f.Id === x.ReceiptPaymentTypeId).Code;
      });
      const find_Receipt = this.invoice.ReceiptPayments.filter((f) => f.ReceiptPaymentTypeCode === ReceiptPaymentTypeEnum.Receipt);
      const result_Receipt = find_Receipt.reduce<number>((accumulator, obj) => {
        return accumulator + obj.Amount;
      }, 0);
      if (this.invoice.CommandCode === InvoiceCommand.PosPayment && this.invoice.Id && this.invoice.PayableTotal > result_Receipt) {
        const receipt = this.addCashReceiptPayment(this.invoice.PayableTotal - result_Receipt);
        this.invoice.posPaymentIndex = receipt.Index;
        this.order.invoice.posPaymentIndex = receipt.Index;
      }
    }

    if (this.invoice.StatusCode === InvoiceStatus.Cleared && this.invoice.ReceiptPayments?.length > 0) {
      if (this.invoice.Debit > 0 && this.invoice.Debit === this.invoice.PayableTotal)
        this.invoice.ReceiptPayments = this.invoice.ReceiptPayments.filter((f) => f.Amount > 0);
      this.invoice.ReceiptPayments.forEach((item) => {
        if (!item.ReceiptPaymentTypeCode)
          item.ReceiptPaymentTypeCode = this.order.receiptPaymentTypeLookup.find((f) => f.Id === item.ReceiptPaymentTypeId).Code;
      });
      const find_Receipt = this.invoice.ReceiptPayments.filter((f) => f.ReceiptPaymentTypeCode === ReceiptPaymentTypeEnum.Receipt);
      const find_Payment = this.invoice.ReceiptPayments.filter((f) => f.ReceiptPaymentTypeCode === ReceiptPaymentTypeEnum.Payment);
      const result_Receipt = find_Receipt.reduce<number>((accumulator, obj) => {
        return accumulator + obj.Amount;
      }, 0);
      const result_Payment = find_Payment.reduce<number>((accumulator, obj) => {
        return accumulator + obj.Amount;
      }, 0);
      // if (
      //   this.invoice.State === RowState.Modify &&
      //   this.invoice.PayableTotal !==
      //     (result_Receipt > result_Payment ? result_Receipt - result_Payment : result_Payment - result_Receipt) -
      //       this.invoice.Credit +
      //       this.invoice.Debit -
      //       this.invoice.Tip
      // ) {
      //   this.addCashReceiptPayment(this.invoice.PayableTotal - (result_Receipt - result_Payment));
      // }
    }
  }
  private addCashReceiptPayment(diff?: number) {
    const receipt = new ReceiptPaymentModel();
    receipt.Amount = diff
      ? diff < 0
        ? diff * -1 - this.invoice.Debit + this.invoice.Credit + this.invoice.Tip
        : diff - this.invoice.Debit + this.invoice.Credit + this.invoice.Tip
      : this.invoice.PayableTotal - this.invoice.Debit + this.invoice.Credit + this.invoice.Tip;
    const hasDefaultPayment = this.invoice.SaleMethodBranch.PaymentMethods.find((f) => f.IsDefault);
    if (hasDefaultPayment) {
      if (receipt.Amount === 0) return;
      this.order.defaultPaymentToSaving = true;
      receipt.PaymentMethodId = hasDefaultPayment.PaymentMethodId;
      receipt.PaymentMethodCode = this.order.paymentMethodTypeLookup.find((f) => f.Id === receipt.PaymentMethodId)?.PaymentMethodCode;
      if (receipt.PaymentMethodCode === PaymentMethodType.TabletPos) this.invoice.CommandCode = InvoiceCommand.TabletPos;
    } else {
      const findLookup = this.order.paymentMethodTypeLookup.find((f) => f.PaymentMethodCode === PaymentMethodEnum.Cash).PaymentMethodTypeId;
      receipt.PaymentMethodId = this.order.paymentMethodTypeLookup.find((f) => f.PaymentMethodTypeId === findLookup).Id;
    }
    if (!diff) {
      receipt.ReceiptPaymentTypeId = this.order.receiptPaymentTypeLookup.find((f) => f.Code === ReceiptPaymentTypeEnum.Receipt).Id;
      receipt.ReceiptPaymentTypeCode = this.order.receiptPaymentTypeLookup.find((f) => f.Code === ReceiptPaymentTypeEnum.Receipt).Code;
    } else {
      if (diff < 0) {
        receipt.ReceiptPaymentTypeId = this.order.receiptPaymentTypeLookup.find((f) => f.Code === ReceiptPaymentTypeEnum.Payment).Id;
        receipt.ReceiptPaymentTypeCode = this.order.receiptPaymentTypeLookup.find((f) => f.Code === ReceiptPaymentTypeEnum.Payment).Code;
      } else {
        receipt.ReceiptPaymentTypeId = this.order.receiptPaymentTypeLookup.find((f) => f.Code === ReceiptPaymentTypeEnum.Receipt).Id;
        receipt.ReceiptPaymentTypeCode = this.order.receiptPaymentTypeLookup.find((f) => f.Code === ReceiptPaymentTypeEnum.Receipt).Code;
      }
    }
    receipt.BranchId = this.invoice.BranchId;
    receipt.InvoiceId = this.invoice.Id;
    receipt.State = RowState.New;
    receipt.Index = this.invoice.ReceiptPayments.length + 1;
    this.invoice.ReceiptPayments.push(receipt);
    this.order.invoice.ReceiptPayments = this.invoice.ReceiptPayments;
    return receipt;
  }
  //تنظیم پیش فرض های فاکتور
  SetInvoiceDefaults() {
    this.invoice.SaleMethodId = this.order.saleMethodBranch?.SaleMethodId;
    this.invoice.CustomerAddress = null;
    this.invoice.isPackingDisable = false;
    this.invoice.User = null;
    if (this.invoice.Changes && !(this.invoice.Changes.length > 0)) {
      this.invoice.Changes = null;
    }
    this.invoice?.Items?.forEach((x) => {
      if (x.Additives && !(x.Additives.length > 0)) {
        x.Additives = null;
      }
      if (x.Descriptions && !(x.Descriptions.length > 0)) {
        x.Descriptions = null;
      }
    });
    if (this.invoice.Changes && !(this.invoice.Changes.length > 0)) {
      this.invoice.Changes = null;
    }
  }
  //تنظیم تغییرات فاکتور
  SetInvoiceChanges() {
    let originalValue = undefined;
    if (this.invoice.OriginalValue) originalValue = JSON.parse(JSON.stringify(this.invoice.OriginalValue));
    else {
      this.invoice.Items.forEach((x) => {
        x.NewQuantity = x.Quantity;
      });
    }
    if (!this.invoice.Debit) this.invoice.Debit = 0;
    if (!this.invoice.Credit) this.invoice.Credit = 0;
    if (originalValue) {
      let invoice = this.invoice;
      let lookups = this.order.invoiceChangesLookups;

      if (lookups && lookups.length > 0) {
        if (!this.invoice.Changes) {
          this.invoice.Changes = [];
        }
        if (originalValue.SalePriceTypeId != invoice.SalePriceTypeId) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.SalePriceType)?.Id;
          this.invoice.Changes.push(invoiceChange);
          this.invoice.Items.forEach((ele) => {
            if (ele.State !== RowState.New) ele.State = RowState.Modify;
          });
        }
        if (originalValue.PackingPrice != invoice.PackingPrice) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.PackingPrice)?.Id;
          this.invoice.Changes.push(invoiceChange);
          this.invoice.Items.forEach((ele) => {
            if (ele.State !== RowState.New) ele.State = RowState.Modify;
          });
          if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
        }
        invoice.ClubCode = invoice.ClubCode ? invoice.ClubCode : undefined;
        originalValue.ClubCode = originalValue.ClubCode ? originalValue.ClubCode : undefined;
        if (originalValue.ClubCode != invoice.ClubCode) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Club)?.Id;
          this.invoice.Changes.push(invoiceChange);
          this.invoice.Items.forEach((ele) => {
            if (ele.State !== RowState.New) ele.State = RowState.Modify;
          });
        }
        if (originalValue.BranchId != invoice.BranchId) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.BranchId)?.Id;
          invoiceChange.LookupCode = lookups.find((lookup) => lookup.Code === InvoiceChanges.BranchId)?.Code;
          this.invoice.Changes.push(invoiceChange);
        }
        if (originalValue.TableId != invoice.TableId) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Table)?.Id;
          this.invoice.Changes.push(invoiceChange);
        }
        //TODO نیازمند به شرط بهتر
        if (
          invoice.SaleMethodBranch?.SaleMethodTitle &&
          originalValue.SaleMethodBranch?.SaleMethodTitle &&
          invoice.SaleMethodBranch.SaleMethodTitle !== originalValue.SaleMethodBranch.SaleMethodTitle
        ) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.SaleMethodBranchId)?.Id;
          this.invoice.Changes.push(invoiceChange);
        }
        let hasDeletedComment = invoice.ReceiptPayments.find((c) => c.State === RowState.Delete && c.Comment === "1000");
        let hasNewEmptyComment = invoice.ReceiptPayments.find((c) => c.State === RowState.New && c.Comment === "");
        if (hasDeletedComment && !hasNewEmptyComment) {
          if (
            invoice.ReceiptPayments &&
            originalValue.ReceiptPayments &&
            originalValue.ReceiptPayments.length > 0 &&
            invoice.ReceiptPayments.length > 0 &&
            invoice.ReceiptPayments.some(
              (x) =>
                (x.State === RowState.New && x.Comment !== "10001") ||
                (x.State === RowState.Delete && x.Comment !== "1000") ||
                x.State === RowState.Modify
            )
          ) {
            let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
            invoiceChange.InvoiceId = invoice.Id;
            invoice.State = RowState.Modify;
            invoiceChange.State = RowState.New;
            invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ReceiptPayment)?.Id;
            this.invoice.Changes.push(invoiceChange);
            if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
          }
        }
        if ((!originalValue.HasClub && invoice.HasClub) || (originalValue.HasClub && !invoice.HasClub)) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Club)?.Id;
          this.invoice.Changes.push(invoiceChange);
        }
        if (originalValue.WaiterId != invoice.WaiterId) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Waiter)?.Id;
          this.invoice.Changes.push(invoiceChange);
        }
        if (
          (originalValue.ShippingCost || (invoice.ShippingCost !== 0 && invoice.ShippingCost)) &&
          originalValue.ShippingCost != invoice.ShippingCost
        ) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ShippingCost)?.Id;
          this.invoice.Changes.push(invoiceChange);
          if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
        }
        if (
          originalValue.TotalService != invoice.TotalService &&
          (!originalValue.TotalService || originalValue.TotalService === 0 || !invoice.TotalService || invoice.TotalService === 0)
        ) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoiceChange.State = RowState.New;
          invoice.State = RowState.Modify;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Service)?.Id;
          this.invoice.Changes.push(invoiceChange);
          this.invoice.Items.forEach((ele) => {
            if (ele.State !== RowState.New) ele.State = RowState.Modify;
          });
          if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
        }
        if (originalValue.Debit != invoice.Debit) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoiceChange.State = RowState.New;
          invoice.State = RowState.Modify;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Debit)?.Id;
          this.invoice.Changes.push(invoiceChange);
          if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
        }
        if (originalValue.Credit != invoice.Credit) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Credit)?.Id;
          this.invoice.Changes.push(invoiceChange);
          if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
        }
        if (originalValue.Tip != invoice.Tip) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Tip)?.Id;
          this.invoice.Changes.push(invoiceChange);
          if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
        }
        if (originalValue.CustomerId != invoice.CustomerId) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Customer)?.Id;
          this.invoice.Changes.push(invoiceChange);
        }

        if (originalValue.AddressId != invoice.AddressId) {
          let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
          invoiceChange.InvoiceId = invoice.Id;
          invoice.State = RowState.Modify;
          invoiceChange.State = RowState.New;
          invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ShippingAddress)?.Id;
          this.invoice.Changes.push(invoiceChange);
        }

        originalValue.Items.forEach((originItem) => {
          if (!invoice.Items.some((s) => s.Id === originItem.Id)) {
            const element = JSON.parse(JSON.stringify(originItem));
            element.State = RowState.Delete;
            element.NewQuantity = originItem.Quantity * -1;
            element.Quantity = 0;
            invoice.Items.push(element);
          }
          let item = invoice.Items.find((i) => i.Id == originItem.Id && i.State !== RowState.Delete);
          if (
            !item &&
            !this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityNegative)?.Id)
          ) {
            let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
            invoiceChange.InvoiceId = invoice.Id;
            invoiceChange.State = RowState.New;
            invoice.State = RowState.Modify;
            invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityNegative)?.Id;
            this.invoice.Changes.push(invoiceChange);
            if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
          }
          if (item) {
            if (item.Quantity - originItem.Quantity != 0) item.NewQuantity = item.Quantity - (originItem.Quantity ?? 0);
            if (
              originalValue.TotalDiscount != invoice.TotalDiscount &&
              !this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.Discount)?.Id)
            ) {
              if (
                originalValue.Discount != invoice.Discount ||
                originItem.RowDiscount != item.RowDiscount ||
                originalValue.IsDiscountPercent != invoice.IsDiscountPercent
              ) {
                let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
                invoiceChange.InvoiceId = invoice.Id;
                invoiceChange.State = RowState.New;
                invoice.State = RowState.Modify;

                invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.Discount)?.Id;
                this.invoice.Changes.push(invoiceChange);
                if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
              }
            }
            if (item.RowDiscount !== originItem.RowDiscount) {
              item.State = RowState.Modify;
            }
            item?.Additives?.forEach((add) => {
              if (!originItem?.Additives?.some((s) => s.Id === add.Id)) {
                add.State = RowState.New;
                if (
                  !this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemAdditivePositive)?.Id)
                ) {
                  let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
                  invoiceChange.InvoiceId = invoice.Id;
                  invoiceChange.State = RowState.New;
                  if (item.Id && item.Id !== 0) this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).State = RowState.Modify;
                  item.State = RowState.Modify;
                  invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemAdditivePositive)?.Id;
                  invoice.State = RowState.Modify;
                  this.invoice.Changes.push(invoiceChange);
                  if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
                }
              }
            });
            item?.Descriptions?.forEach((add) => {
              if (!originItem?.Descriptions?.some((s) => s.Id === add.Id)) {
                add.State = RowState.New;
                if (item.Id && item.Id !== 0) this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).State = RowState.Modify;
                if (!this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemDescription)?.Id)) {
                  let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
                  invoiceChange.InvoiceId = invoice.Id;
                  invoiceChange.State = RowState.New;
                  if (item.Id && item.Id !== 0) this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).State = RowState.Modify;
                  item.State = RowState.Modify;
                  invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemDescription)?.Id;
                  invoice.State = RowState.Modify;
                  this.invoice.Changes.push(invoiceChange);
                }
              }
            });
            /// add Delete Item To Items
            originItem?.Additives?.forEach((add) => {
              if (!item?.Additives?.some((s) => s.Id === add.Id)) {
                add.State = RowState.Delete;
                if (!item.Additives) item.Additives = [];
                item.Additives.push(add);
                if (item.Id && item.Id !== 0) this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).State = RowState.Modify;
                this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).Additives = item.Additives;
                if (
                  !this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemAdditiveNegative)?.Id)
                ) {
                  let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
                  invoiceChange.InvoiceId = invoice.Id;
                  invoiceChange.State = RowState.New;
                  if (item.Id && item.Id !== 0) this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).State = RowState.Modify;
                  item.State = RowState.Modify;
                  invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemAdditiveNegative)?.Id;
                  invoice.State = RowState.Modify;
                  this.invoice.Changes.push(invoiceChange);
                  if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
                }
              }
            });
            originItem?.Descriptions?.forEach((add) => {
              if (!item.Descriptions?.some((s) => s.Id === add.Id)) {
                add.State = RowState.Delete;
                if (!item.Descriptions) item.Descriptions = [];
                item.Descriptions.push(add);
                if (item.Id && item.Id !== 0) this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).State = RowState.Modify;
                this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).Descriptions = item.Descriptions;
                if (!this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemDescription)?.Id)) {
                  let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
                  invoiceChange.InvoiceId = invoice.Id;
                  invoiceChange.State = RowState.New;
                  invoice.State = RowState.Modify;
                  invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemDescription)?.Id;
                  invoice.State = RowState.Modify;
                  this.invoice.Changes.push(invoiceChange);
                }
              }
            });
            if (originItem.Quantity !== item.Quantity) {
              let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
              invoiceChange.InvoiceId = invoice.Id;
              invoiceChange.State = RowState.New;
              invoice.State = RowState.Modify;
              if (
                item.Quantity > originItem.Quantity &&
                !this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityPositive)?.Id)
              ) {
                invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityPositive)?.Id;
                this.invoice.Changes.push(invoiceChange);
                if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
              }
              if (
                item.Quantity < originItem.Quantity &&
                !this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityNegative)?.Id)
              ) {
                invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityNegative)?.Id;
                this.invoice.Changes.push(invoiceChange);
                if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
              }
            }
          }
        });
        if (!this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityPositive)?.Id)) {
          invoice.Items.forEach((item) => {
            let origin = originalValue.Items.find((i) => i.Id == item.Id);
            if (!origin) {
              item.NewQuantity = item.Quantity;
              item.State = RowState.New;
            }
            if (
              !origin &&
              !this.invoice.Changes.some((s) => s.LookupId === lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityPositive)?.Id)
            ) {
              let invoiceChange: InvoiceChangesLookup = new InvoiceChangesLookup();
              invoiceChange.InvoiceId = invoice.Id;
              invoiceChange.State = RowState.New;
              if (item.Id && item.Id !== 0) this.invoice.Items.find((f) => f.Id === item.Id && f.Index === item.Index).State = RowState.Modify;
              invoice.State = RowState.Modify;
              invoiceChange.LookupId = lookups.find((lookup) => lookup.Code === InvoiceChanges.ItemQuantityPositive)?.Id;
              this.invoice.Changes.push(invoiceChange);
              if (!this.order.currentUser.PreventChangeClear) this.invoice.ClearedUserId = this.accountService.authService.currentUser.Id;
            }
          });
        }
        invoice.Items.forEach((item) => {
          if (!originalValue.Items.some((s) => s.Id === item.Id)) {
            item.NewQuantity = item.Quantity;
            item.State = RowState.New;
          }
          if (item.State != RowState.Delete && originalValue.Items.some((s) => s.Id === item.Id)) {
            item.State = RowState.Modify;
          }
          if (item.State == RowState.Delete) {
            item.Additives.forEach((f) => {
              f.State = RowState.Delete;
            });
            item.Descriptions.forEach((f) => {
              f.State = RowState.Delete;
            });
          }
        });
      }
    }
  }

  setDepositChanges(deposit: DepositModel) {
    let originalValue: DepositModel = undefined;
    if (this.order.originalDeposit) originalValue = JSON.parse(JSON.stringify(this.order.originalDeposit));
    if (originalValue) {
      if (!deposit.Changes) deposit.Changes = [];
      for (const key in DepositChangedFieldEnum) {
        if (typeof DepositChangedFieldEnum[key] === "number") this.addDepositChange(deposit, originalValue, key);
      }
      const addedItems = deposit.DepositPersonnelList.filter((item2) => !originalValue.DepositPersonnelList.some((item1) => item1.Id === item2.Id));
      const deletedItems = originalValue.DepositPersonnelList.filter((item1) => !deposit.DepositPersonnelList.some((item2) => item2.Id === item1.Id));
      const editedItems = deposit.DepositPersonnelList.filter((item2) => {
        const correspondingItem1 = originalValue.DepositPersonnelList.find((item1) => item1.Id === item2.Id);
        const personnelChanged = correspondingItem1.PersonnelId !== item2.PersonnelId;
        const amountChanged = correspondingItem1.Amount !== item2.Amount;
        return correspondingItem1 && (personnelChanged || amountChanged);
      });
      if (addedItems.length) this.addDepositPersonnelChange(deposit, RowState.New);
      if (editedItems.length) this.addDepositPersonnelChange(deposit, RowState.Modify);
      if (deletedItems.length) this.addDepositPersonnelChange(deposit, RowState.Delete);
    }
  }

  addDepositChange(deposit: DepositModel, originalValue: DepositModel, field: string): void {
    let depositChange: DepositChanges = new DepositChanges();
    if (field === "ServingFoodDate") {
      if (typeof deposit[field] === "string") {
        deposit[field] = new Date(originalValue[field]);
      }
      if (deposit[field].toDateString() !== new Date(originalValue[field]).toDateString()) addToChanges();
    } else if (originalValue[field] !== deposit[field]) addToChanges();

    function addToChanges() {
      depositChange.ChangedFieldCode = DepositChangedFieldEnum[field];
      depositChange.State = null;
      deposit.Changes.push(depositChange);
    }
  }

  addDepositPersonnelChange(deposit: DepositModel, state: RowState): void {
    let depositChange: DepositChanges = new DepositChanges();
    depositChange.State = state;
    deposit.Changes.push(depositChange);
  }

  SetInvoiceStatuses(statusCode: number, commandCode: number, invoiceMode: InvoiceMode) {
    this.invoice.OldStatusCode = this.invoice.StatusCode;
    this.invoice.Status = this.order.invoiceStatusLookups.find((lookup) => lookup.Code === statusCode);
    this.invoice.Command = this.order.invoiceCommandLookups.find((lookup) => lookup.Code === commandCode);
    this.invoice.CommandCode = this.invoice.Command?.Code;
    this.invoice.StatusCode = this.invoice.Status?.Code;
    this.invoice.State = RowState.NoChange;
    statusCode > 0 ? (this.invoice.StatusId = this.invoice.Status?.Id) : true;
    commandCode > 0 ? (this.invoice.CommandId = this.invoice.Command?.Id) : true;
    if (invoiceMode === InvoiceMode.Update) {
      let invoicePositivePayable = this.order.invoicePayableChangeLookups.find((lookup) => lookup.Code === InvoicePayableChange.Positive)?.Id;
      let invoiceNegativePayable = this.order.invoicePayableChangeLookups.find((lookup) => lookup.Code === InvoicePayableChange.Negative)?.Id;
      if (this.invoice.OriginalValue) {
        this.invoice.PayableTotal > this.invoice.OriginalValue.PayableTotal
          ? (this.invoice.PayableChangeId = invoicePositivePayable)
          : this.invoice.PayableTotal < this.invoice.OriginalValue.PayableTotal
          ? (this.invoice.PayableChangeId = invoiceNegativePayable)
          : true;
      }
    }
    this.invoice.HasChange =
      this.order.invoice.Items.some((c) => c.NewQuantity != 0) || this.order.itemQuantityChanged || this.order.invoice.hasChangedTable;
    this.invoice.SaleMethodBranch = this.order.saleMethodBranch;
    this.invoice.SaleMethodNatureCode = this.order.saleMethodBranch.SaleMethodNatureCode;
    this.invoice.SaleMethodBranchTitle = this.order.saleMethodBranch.SaleMethodTitle;
    this.invoice.CreatedUserName = this.accountService.authService.currentUser.DisplayName;
  }
  isCustomerPrint(model: Invoice) {
    return (
      (model.SaleMethodNatureCode === SaleMethodNature.Restaurant &&
        (model.CommandCode == InvoiceCommand.CustomerPrint ||
          ((!model.CustomerPrintCount ||
            model.CustomerPrintCount <= 0 ||
            model.OldSaleMethodBranchId ||
            (model.HasChange && model.OldStatusCode !== InvoiceStatus.Cleared)) &&
            model.CommandCode === InvoiceCommand.Clear))) ||
      (model.SaleMethodNatureCode === SaleMethodNature.Delivery && model.CommandCode === InvoiceCommand.CustomerPrint) ||
      model.CommandCode === InvoiceCommand.ReprintForCustomer ||
      model.CommandCode === InvoiceCommand.ReceiptPrint ||
      (model.SaleMethodNatureCode === SaleMethodNature.Delivery &&
        model.CommandCode === InvoiceCommand.Assign &&
        model.SaleMethodBranch?.DeliveryCustomerPrintTimeCode === DeliveryCustomerPrintTime.Assign) ||
      (model.SaleMethodNatureCode === SaleMethodNature.Delivery &&
        model.CommandCode === InvoiceCommand.PreparationPrint &&
        model.SaleMethodBranch?.DeliveryCustomerPrintTimeCode === DeliveryCustomerPrintTime.PreparationPrint) ||
      (model.SaleMethodNatureCode === SaleMethodNature.FastFood && model.CommandCode === InvoiceCommand.Clear)
    );
  }
  PrintData() {
    this.localSettingService.tabsservice = this.order.tabsservice;
    const printList: Invoice[] = [];
    this.invoice.PrintPolicyPrintTime = PrintPolicyPrintTimeEnum.CustomerPrint;
    printList.push(this.invoice);
    printList.forEach((p) => {
      this.invoicePrint.PrintLocalInvoice(p).then((inv) => {
        this.localSettingService.printData(inv[0]);
      });
    });
  }
  checkPosPayment() {
    if (this.invoice.CommandCode === InvoiceCommand.PosPayment || this.invoice.CommandCode === InvoiceCommand.TabletPos) {
      this.posPaymentInvoice = Object.assign({}, this.invoice);
    }
  }
  //ذخیره تغییرات فاکتور جاری در دیتابیس
  async UpdateInvoice() {
    if (!this.order.currentUser) {
      await this.httpCommonService
        .get("Authorization/CurrentUser/" + this.accountService.authService.currentUser.Id)
        .pipe(take(1))
        .toPromise()
        .then((data: User) => {
          this.invoice.createdUserPhoneNUmber = data.PhoneNumber;
        });
    } else this.invoice.createdUserPhoneNUmber = this.order.currentUser.PhoneNumber;
    this.checkPosPayment();
    const DefultPayment = this.order.saleMethodBranch?.PaymentMethods?.find((s) => s.IsDefault);
    const localSetting = this.storage.getData(ClearableCache.LocalSetting);
    const isSamanPos = localSetting.some((x) => x.PaymentMethodId === DefultPayment?.PaymentMethodId);
    if (isSamanPos) {
      this.order.splashFormService
        .openDialogwithCancelButton("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.WaitForCardDraw"))
        .subscribe((flag: any) => {
          if (!flag) {
            const ComputerName = this.storage.getData(ClearableCache.ComputerName);
            this.httpCommonService
              .get(`ReceiptPayment/CancelSamanaPosRequest/${ComputerName}`)
              .pipe(take(1))
              .subscribe((data: any) => {
                this.sts.showToast(
                  "danger",
                  "",
                  `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.PaymentSuccessfullyCanceled")}`
                );
              });
          }
        });
    } else if (!this.order.invoice?.ReceiptPayments?.some((s) => s.ShowPospayment && s.State != RowState.Modify)) {
      this.order.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Storing"));
    }

    if (this.invoice.CommandCode === InvoiceCommand.TabletPos) {
      this.order.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.WaitForCardDraw"));
      const hasDefultPayment = this.invoice.SaleMethodBranch.PaymentMethods.find((f) => f.IsDefault);
      let ReceiptPayment;
      if (hasDefultPayment) {
        ReceiptPayment = this.posPaymentInvoice.ReceiptPayments[0];
      } else {
        ReceiptPayment = this.posPaymentInvoice.ReceiptPayments.find((f) => f.Index === this.posPaymentInvoice.posPaymentIndex);
      }
      const isSuccess = await this.tabletPos.tabletPosClearing(ReceiptPayment.Amount).then(
        (resolve) => {
          this.order.splashFormService.closeLoading();
          this.order.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Storing"));
          return true;
        },
        (reject) => {
          if (reject?.ER && reject.ER !== "null")
            this.sts.showDialog(reject.ER, this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Error"));
          return false;
        }
      );
      if (!isSuccess) {
        if (hasDefultPayment) {
          this.invoice.ReceiptPayments = this.invoice.ReceiptPayments.filter((x) => x.Index !== ReceiptPayment.Index);
          this.order.invoice.ReceiptPayments = this.invoice.ReceiptPayments;
        }
        this.order.splashFormService.closeLoading();
        this.order.invoice.ReceiptPayments = this.order.invoice.ReceiptPayments.filter((f) => f.Index !== this.posPaymentInvoice.posPaymentIndex);
        this.saveEnd.isStopped = false;
        this.saveEnd.hasError = false;
        this.isStartAction = 0;
        this.ActionFinish.next(true);
        this.saveEnd.next(false);
        this.order.detectChanges();
        return;
      }
    }
    if (this.invoice.CommandCode === InvoiceCommand.CustomerTabletPrint) {
      const isSuccess = await this.tabletPos.tabletPosPrint(this.invoice, this.accountService.authService.currentInformation().BrandName).then(
        (resolve) => {
          this.order.splashFormService.closeLoading();
          this.order.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Storing"));
          return true;
        },
        (reject) => {
          if (reject?.ER && reject.ER !== "null")
            this.sts.showDialog(reject.ER, this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Error"));
          return false;
        }
      );
      if (!isSuccess) {
        this.order.splashFormService.closeLoading();
        this.saveEnd.isStopped = false;
        this.saveEnd.hasError = false;
        this.isStartAction = 0;
        this.ActionFinish.next(true);
        this.saveEnd.next(false);
        this.order.detectChanges();
        return;
      }
    }
    if (this.invoice.PreprationDeliveryTime) {
      if (this.invoice.PrintDescription)
        this.invoice.PrintDescription += `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.DeliveryTime")}:${
          this.invoice.PreprationDeliveryTime
        }`;
      else
        this.invoice.PrintDescription = `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.DeliveryTime")}:${
          this.invoice.PreprationDeliveryTime
        }`;
    }
    this.invoicePrintService.PreData();
    this.invoice.HasLocalPrtinter = this.invoicePrint.HasLocalPrint && this.isCustomerPrint(this.invoice);
    this.reviewEntity();

    this.httpCommonService
      .update("Invoice", this.invoice)
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          this.order.splashFormService.closeLoading();
          this.order.invoice.Id = data;
          this.httpCommonService
            .get(`Customer/GetCustomerDetails/${this.invoice.CustomerId}`)
            .pipe(take(1))
            .subscribe((customer: Customer) => {
              this.invoice.Customer = customer;
              if (this.invoice.CommandCode === InvoiceCommand.CustomerTabletPrint) {
                this.order.splashFormService.closeLoading();
                this.isStartAction = 0;
                this.saveEnd.isStopped = false;
                this.saveEnd.hasError = false;
                this.ActionFinish.next(true);
                this.order.detectChanges();
              } else if (this.posPaymentInvoice && this.invoice.CommandCode === InvoiceCommand.TabletPos) {
                this.order.splashFormService.closeLoading();
                this.posPaymentInvoice.Id = data ? data : this.invoice.Id;
                this.isStartAction = 0;
                this.saveEnd.isStopped = false;
                this.saveEnd.hasError = false;
                this.ActionFinish.next(true);
                this.saveEnd.next(this.posPaymentInvoice);
                this.order.detectChanges();
              } else {
                if (this.invoice.HasLocalPrtinter || this.order.currentBranch?.HasLocalService || this.order.logInBranch.FoodTruck) {
                  if (this.invoice.OldTableId && this.invoice.TableId && this.invoice.OldTableId != this.invoice.TableId) {
                    if (this.invoice.PrintDescription)
                      this.invoice.PrintDescription += `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.InvoiceDeskFrom")} ${
                        this.invoice.OldTableTitle
                      } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.To")}  ${this.invoice.TableTitle} ${this.translate(
                        "ClientApp.FrontOffice.Order.Providers.InvoiceAction.WasChanged"
                      )}`;
                    else
                      this.invoice.PrintDescription = `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.InvoiceDeskFrom")} ${
                        this.invoice.OldTableTitle
                      } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.To")}  ${this.invoice.TableTitle} ${this.translate(
                        "ClientApp.FrontOffice.Order.Providers.InvoiceAction.WasChanged"
                      )}`;
                  }
                  if (
                    this.invoice.OldSaleMethodBranchId ||
                    this.invoice.CommandCode == InvoiceCommand.Cancel ||
                    this.invoice.CommandCode == InvoiceCommand.Delete
                  ) {
                    this.httpCommonService
                      .get(`Invoice/GetInvoiceCodeById/${data}`)
                      .pipe(take(1))
                      .subscribe((invoicePrintLocal: InvoicePrintLocal) => {
                        this.invoice.NewNumberingInDate = invoicePrintLocal.NumberingInDate;
                        this.invoice.ShamsiCreatedDate = moment(invoicePrintLocal.CreateDateTime).locale("fa").format("YYYY/MM/DD").toString();
                        this.invoice.CreateDateTime = moment(invoicePrintLocal.CreateDateTime).locale("fa").format("HH:mm").toString();
                        this.invoicePrint.currentBranch = this.order.currentBranch;
                        if (this.invoice.OldSaleMethodBranchId != null) {
                          const saleMethodTitle: string = this.order.saleMethodList.find(
                            (f) => f.Id == this.invoice.OldSaleMethodBranchId
                          ).SaleMethodTitle;
                          if (this.invoice.PrintDescription)
                            this.invoice.PrintDescription += `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Invoice")} ${
                              this.invoice.NumberingInDate
                            } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Sale")} ${saleMethodTitle} ${this.translate(
                              "ClientApp.FrontOffice.Order.Providers.InvoiceAction.ToInvoice"
                            )} ${this.invoice.NewNumberingInDate} ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Sale")} ${
                              this.invoice.SaleMethodBranchTitle
                            } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Became")} `;
                          else
                            this.invoice.PrintDescription = `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Invoice")} ${
                              this.invoice.NumberingInDate
                            } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Sale")} ${saleMethodTitle} ${this.translate(
                              "ClientApp.FrontOffice.Order.Providers.InvoiceAction.ToInvoice"
                            )} ${this.invoice.NewNumberingInDate} ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Sale")} ${
                              this.invoice.SaleMethodBranchTitle
                            } ${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Became")} `;
                        }
                        this.invoice.NumberingInDate = this.invoice.NewNumberingInDate;
                        this.invoicePrint.PrintLocalInvoice(this.invoice, true);
                        if (
                          this.invoice.OldSaleMethodBranchId != null ||
                          this.invoice.CommandCode == InvoiceCommand.Cancel ||
                          this.invoice.CommandCode == InvoiceCommand.Delete
                        ) {
                          if (!(this.invoice.SaleMethodNatureCode === SaleMethodNature.Delivery && this.invoice.OldSaleMethodBranchId != null)) {
                            this.invoicePrint.printDescription(this.invoice);
                          }
                        }
                      });
                  } else {
                    this.httpCommonService
                      .get(`Invoice/GetInvoiceCodeById/${data}`)
                      .pipe(take(1))
                      .subscribe((invoicePrintLocal: InvoicePrintLocal) => {
                        this.invoicePrint.currentBranch = this.order.currentBranch;
                        this.invoice.ShamsiCreatedDate = moment(invoicePrintLocal.CreateDateTime).locale("fa").format("YYYY/MM/DD").toString();
                        this.invoice.CreateDateTime = moment(invoicePrintLocal.CreateDateTime).locale("fa").format("HH:mm").toString();
                        this.invoicePrint.PrintLocalInvoice(this.invoice, true);
                      });
                  }
                }
                if (this.posPaymentInvoice && this.invoice.CommandCode === InvoiceCommand.PosPayment)
                  this.posPaymentInvoice.Id = data ? data : this.invoice.Id;
                let posRes = this.invoice.CommandCode !== InvoiceCommand.PosPayment ? true : this.posPaymentInvoice;
                this.isStartAction = 0;
                this.saveEnd.isStopped = false;
                this.saveEnd.hasError = false;
                this.ActionFinish.next(true);
                this.saveEnd.next(posRes);
                this.order.detectChanges();
              }
              if (
                (this.order.currentActivePage === ActivePageEnum.Order ||
                  this.order.currentActivePage === ActivePageEnum.OrderItem ||
                  this.order.currentActivePage === ActivePageEnum.Invoice) &&
                this.invoice.CommandCode !== InvoiceCommand.PosPayment &&
                this.invoice.CommandCode !== InvoiceCommand.TabletPos
              ) {
                this.order.splashFormService.closeLoading();
                this.order.newInvoice();
              }
            });
        },
        (error) => {
          if (this.order.defaultPaymentToSaving) this.order.invoice.ReceiptPayments = this.order.invoice.ReceiptPayments.filter((x) => x.Id);
          this.saveEnd.next(false);
          let message = Utilities.getHttpResponseMessage(error);
          if (
            message.includes(this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.EnoughStockFor")) &&
            this.order.logInBranch.InvDailyBalanceInhibitorId
          ) {
            this.sts.showDialog(
              `${message}`,
              this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
              DialogType.confirm,
              () => this.userUpdateConfirm(this.invoice)
            );
          } else {
            this.sts.showDialog(
              `${message}`,
              this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
              DialogType.alert,
              () => {
                this.order.splashFormService.closeLoading();
              }
            );
          }
          this.isStartAction = 0;
          this.ActionFinish.next(true);
        }
      );
  }
  userInsertConfirm(model: Invoice) {
    this.httpCommonService
      .create("Invoice", model)
      .pipe(take(1))
      .subscribe(
        async (data: any) => {
          this.order.splashFormService.closeLoading();
          if (this.invoice.HasLocalPrtinter) this.PrintData();
          if (
            this.order.currentActivePage === ActivePageEnum.Order ||
            this.order.currentActivePage === ActivePageEnum.OrderItem ||
            this.order.currentActivePage === ActivePageEnum.Invoice
          ) {
            setTimeout(() => {
              this.order.newInvoice();
            }, 50);
          }

          // this.sts.showToast('success', 'موفقیت آمیز', `اطلاعات با موفقیت ذخیره شد`);
          this.saveEnd.next(true);
          this.isStartAction = 0;
          this.ActionFinish.next(true);
          this.order.detectChanges();
        },
        (error) => {
          let message = Utilities.getHttpResponseMessage(error);
          this.sts.showDialog(
            `${message}`,
            this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
            DialogType.alert,
            () => {
              this.order.splashFormService.closeLoading();
            }
          );
          this.isStartAction = 0;
          this.ActionFinish.next(true);
        }
      );
  }
  userUpdateConfirm(model: Invoice) {
    this.httpCommonService
      .update("Invoice", model)
      .pipe(take(1))
      .subscribe(
        (data: any) => {
          this.order.splashFormService.closeLoading();
          if (this.invoice.HasLocalPrtinter) this.PrintData();
          if (
            this.order.currentActivePage === ActivePageEnum.Order ||
            this.order.currentActivePage === ActivePageEnum.OrderItem ||
            this.order.currentActivePage === ActivePageEnum.Invoice
          )
            this.order.newInvoice();
          this.saveEnd.next(true);
          this.isStartAction = 0;
          this.ActionFinish.next(true);
        },
        (error) => {
          this.order.splashFormService.closeLoading();
          let message = Utilities.getHttpResponseMessage(error);
          this.sts.showDialog(`${message}`, this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"));
          this.isStartAction = 0;
          this.ActionFinish.next(true);
        }
      );
  }
  /// خالی کردن property های اضافی
  reviewEntity() {
    this.invoice.CurrentUserId = this.order.currentUser.Id;
    this.invoice.CurrentBranchId = this.order.currentBranch?.Id;
    this.invoice.Command = null;
    this.invoice.Status = null;
    this.invoice.DeliveryCustomerPrintTimeCode = this.invoice.SaleMethodBranch?.DeliveryCustomerPrintTimeCode;
    this.invoice.SaleMethodBranch = null;
    this.invoice.CustomerTitle = this.invoice?.Customer?.Title;
    if (!this.invoice.Discount) this.invoice.Discount = 0;
    if (!this.invoice.Debit) this.invoice.Debit = 0;
    if (!this.invoice.Credit) this.invoice.Credit = 0;
    if (this.invoice?.ReceiptPayments && this.invoice?.ReceiptPayments?.length > 0) {
      for (var item of this.invoice?.ReceiptPayments) {
        if (!item.ReceiptPaymentTypeCode) {
          item.ReceiptPaymentTypeCode = this.order.receiptPaymentTypeLookup.find((f) => f.Id === item.ReceiptPaymentTypeId).Code;
        }
        item.ReceiptPaymentType = null;
        item.PaymentMethod = null;
        if (!item.Id) item.Id = 0;
      }
    }
    if (this.invoice.PayableTotal === 0) {
      this.invoice.Debit = 0;
      this.invoice.Credit = 0;
      this.invoice?.ReceiptPayments?.forEach((re) => {
        re.Amount = 0;
      });
    }
    this.invoice.Customer = null;
    this.invoice.OriginalValue = null;
    if (this.invoice.TotalDiscount <= 0) {
      this.invoice.DiscountPrice = 0;
      this.invoice.Discount = 0;
    }
    if (this.invoice.StatusCode === InvoiceStatus.Cleared && !this.invoice.ClearedUserId) {
      this.invoice.ClearedUserId = this.order.currentUser.Id;
    }
  }
  //ایجاد فاکتور جدید در دیتابیس
  async InsertInvoice() {
    this.checkPosPayment();
    const DefultPayment = this.order.saleMethodBranch?.PaymentMethods?.find((s) => s.IsDefault);
    const localSetting = this.storage.getData(ClearableCache.LocalSetting);
    const isSamanPos = localSetting.some((x) => x.PaymentMethodId === DefultPayment?.PaymentMethodId);
    if (isSamanPos && this.order.currentSaleMethodNature !== this.order.SaleMethodNature.Restaurant) {
      this.order.splashFormService
        .openDialogwithCancelButton("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.WaitForCardDraw"))
        .subscribe((flag: any) => {
          if (!flag) {
            const ComputerName = this.storage.getData(ClearableCache.ComputerName);
            this.httpCommonService
              .get(`ReceiptPayment/CancelSamanaPosRequest/${ComputerName}`)
              .pipe(take(1))
              .subscribe((data: any) => {
                this.sts.showToast(
                  "danger",
                  "",
                  `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.PaymentSuccessfullyCanceled")}`
                );
              });
          }
        });
    } else if (!this.order.invoice?.ReceiptPayments?.some((s) => s.ShowPospayment && s.State != RowState.Modify)) {
      this.order.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Storing"));
    }
    if (this.invoice.CommandCode === InvoiceCommand.TabletPos) {
      this.order.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.WaitForCardDraw"));
      const hasDefultPayment = this.invoice.SaleMethodBranch.PaymentMethods.find((f) => f.IsDefault);
      let ReceiptPayment: ReceiptPaymentModel;
      if (hasDefultPayment) {
        ReceiptPayment = this.posPaymentInvoice.ReceiptPayments[0];
      } else {
        ReceiptPayment = this.posPaymentInvoice.ReceiptPayments.find((f) => f.Index === this.posPaymentInvoice.posPaymentIndex);
      }
      const isSuccess = await this.tabletPos.tabletPosClearing(ReceiptPayment.Amount).then(
        (resolve) => {
          this.order.splashFormService.closeLoading();
          this.order.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Storing"));
          return true;
        },
        (reject) => {
          if (reject?.ER && reject.ER !== "null")
            this.sts.showDialog(reject.ER, this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Error"));
          return false;
        }
      );
      if (!isSuccess) {
        // اگر ریسیپت پیمنتی اضافه شده و ارور داریم باید اون رو پاک کنیم
        if (hasDefultPayment) {
          this.invoice.ReceiptPayments = this.invoice.ReceiptPayments.filter((x) => x.Index !== ReceiptPayment.Index);
          this.order.invoice.ReceiptPayments = this.invoice.ReceiptPayments;
        }
        this.order.splashFormService.closeLoading();
        this.order.invoice.ReceiptPayments = this.order.invoice.ReceiptPayments.filter((f) => f.Index !== this.posPaymentInvoice.posPaymentIndex);
        this.saveEnd.isStopped = false;
        this.saveEnd.hasError = false;
        this.isStartAction = 0;
        this.ActionFinish.next(true);
        this.saveEnd.next(false);
        this.order.detectChanges();
        return;
      }
    }
    if (this.invoice.PreprationDeliveryTime) {
      if (this.invoice.PrintDescription)
        this.invoice.PrintDescription += `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.DeliveryTime")}:${
          this.invoice.PreprationDeliveryTime
        }`;
      else
        this.invoice.PrintDescription = `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.DeliveryTime")}:${
          this.invoice.PreprationDeliveryTime
        }`;
    }
    this.localSettingService.tabsservice = this.order.tabsservice;
    this.invoicePrintService.PreData();
    this.invoice.HasLocalPrtinter = this.invoicePrint?.HasLocalPrint && this.isCustomerPrint(this.invoice);
    this.reviewEntity();
    if (this.accountService.authService?.currentInformation()?.OrderServices && this.order.saleMethodBranch.HasDeposit) {
      this.order.depositFormGroup.controls["Invoice"].setValue(this.order.invoice);
      this.order.depositFormGroup.controls["InvoiceId"].setValue(0);
      this.order.depositFormGroup.controls["DepositPersonnelList"].setValue(this.order.depositPersonnelList);
      const deposit = this.order.depositFormGroup.value;
      this.invoice.Deposit = deposit;
    }
    this.httpCommonService
      .create("Invoice", this.invoice)
      .pipe(take(1))
      .subscribe(
        async (invoiceId: any) => {
          this.order.splashFormService.closeLoading();
          this.order.invoice.Id = invoiceId;
          const currentBranch = this.order.Branches.find((x) => x.Id === this.invoice.BranchId) || this.order.logInBranch;
          if (this.invoice.HasLocalPrtinter || currentBranch?.HasLocalService || currentBranch?.FoodTruck) {
            if (!this.order.currentUser) {
              await this.httpCommonService
                .get("Authorization/CurrentUser/" + this.accountService.authService.currentUser.Id)
                .pipe(take(1))
                .toPromise()
                .then((data: User) => {
                  this.invoice.createdUserPhoneNUmber = data.PhoneNumber;
                });
            } else this.invoice.createdUserPhoneNUmber = this.order.currentUser.PhoneNumber;
            this.httpCommonService
              .get(`Invoice/GetInvoiceCodeById/${invoiceId}`)
              .pipe(take(1))
              .subscribe((invoicePrintLocal: InvoicePrintLocal) => {
                this.invoice.NumberingInDate = invoicePrintLocal.NumberingInDate;
                this.invoice.ShamsiCreatedDate = moment(invoicePrintLocal.CreateDateTime).locale("fa").format("YYYY/MM/DD").toString();
                this.invoice.CreateDateTime = moment(invoicePrintLocal.CreateDateTime).locale("fa").format("HH:mm").toString();
                this.invoicePrint.currentBranch = currentBranch;
                this.invoice.Items.forEach((it) => {
                  it.NewQuantity = it.Quantity;
                });
                this.httpCommonService
                  .get(`Customer/GetCustomerDetails/${this.invoice.CustomerId}`)
                  .pipe(take(1))
                  .subscribe((customer: Customer) => {
                    this.invoice.Customer = customer;
                    this.invoicePrint.PrintLocalInvoice(this.invoice, true);
                  });
              });
          }

          if (
            (this.posPaymentInvoice && this.invoice.CommandCode === InvoiceCommand.PosPayment) ||
            this.invoice.CommandCode === InvoiceCommand.TabletPos
          )
            this.posPaymentInvoice.Id = invoiceId;
          let posRes =
            this.invoice.CommandCode !== InvoiceCommand.PosPayment && this.invoice.CommandCode !== InvoiceCommand.TabletPos
              ? true
              : this.posPaymentInvoice;
          this.saveEnd.isStopped = false;
          this.saveEnd.hasError = false;
          this.saveEnd.next(posRes);
          this.isStartAction = 0;
          this.ActionFinish.next(true);
          this.order.detectChanges();
          if (
            (this.order.currentActivePage === ActivePageEnum.Order ||
              this.order.currentActivePage === ActivePageEnum.OrderItem ||
              this.order.currentActivePage === ActivePageEnum.Invoice) &&
            this.invoice.CommandCode !== InvoiceCommand.PosPayment &&
            this.invoice.CommandCode !== InvoiceCommand.TabletPos
          ) {
            this.order.newInvoice();
          }
        },
        (error) => {
          this.isStartAction = 0;
          this.ActionFinish.next(true);
          this.saveEnd.next(false);
          let message = Utilities.getHttpResponseMessage(error);
          this.order.invoice.ReceiptPayments = [];
          if (
            message.includes(this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.EnoughStockFor")) &&
            this.order.logInBranch.InvDailyBalanceInhibitorId
          ) {
            this.sts.showDialog(
              `${message}`,
              this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
              DialogType.confirm,
              () => this.userInsertConfirm(this.invoice)
            );
          } else {
            this.sts.showDialog(
              `${message}`,
              this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage"),
              DialogType.alert,
              () => {
                this.order.splashFormService.closeLoading();
              }
            );
          }
        }
      );
  }
  /// چک کزدن میزان اعتبار باقیمانده
  checkRemainCredit() {
    const invoice = Object.assign({}, this.invoice);
    invoice.SaleMethodBranch = null;
    invoice.Changes = null;
    invoice.Command = null;
    invoice.OriginalValue = null;
    invoice.Status = null;
    invoice.Customer = null;
    invoice.Items = null;
    if (!invoice.Discount) invoice.Discount = 0;
    if (!this.invoice.Debit) invoice.Debit = 0;
    if (!this.invoice.Credit) invoice.Credit = 0;
    this.httpCommonService
      .create(`Invoice/GetCredit`, invoice)
      .pipe(take(1))
      .subscribe(
        (value: number) => {
          if (this.invoice.Customer.CreditLimit > 0 && this.invoice.Debit > 0 && this.invoice.Customer.CreditLimit < value) {
            if (this.invoice.Customer.CreditControlTypeCode === CreditControlType.Warning) {
              this.isStartAction = 0;
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.EnteredDebtExceedsCustomerCreditLimit"),
                this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Warning"),
                DialogType.confirm,
                () => {
                  if (this.invoice?.Customer?.HasCredit && this.invoice?.Customer?.CreditLimit > 0) {
                    if (this.invoice.StatusId > 0 && this.invoice.CommandId > 0) {
                      if (this.isValid(this.invoice)) this.invoice.Id ? this.UpdateInvoice() : this.InsertInvoice();
                      this.isStartAction = 0;
                    } else {
                      this.sts.showDialog(
                        `${this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.InvoiceStatusIinvalid")}`,
                        this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.ErrorMessage")
                      );
                      this.isStartAction = 0;
                      this.ActionFinish.next(true);
                      return false;
                    }
                  }
                }
              );
              this.isStartAction = 0;
              this.ActionFinish.next(true);
            } else {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.EnteredDebtThanCustomerCreditLimit"),
                this.translate("ClientApp.FrontOffice.Order.Providers.InvoiceAction.Error")
              );
              this.isStartAction = 0;
              this.ActionFinish.next(-100);
              return false;
            }
          } else {
            this.invoice.CustomerTotalDebit = value;
            this.invoice.Id ? this.UpdateInvoice() : this.InsertInvoice();
          }
        },
        (err) => {
          this.isStartAction = 0;
          this.ActionFinish.next(true);
        }
      );
  }
  //جهت نمایش صفحه گارسون ها در دسترسی سریع
  openFastAccess(value: FastAccessEnum) {
    setTimeout(() => {
      this.order._opened = true;
      this.order.selectedFastAccess = value;
      this.order.detectChanges();
    }, 50);
  }
  focus(id: string) {
    const input: HTMLInputElement = document.getElementById(id) as HTMLInputElement;
    input.focus();
    if (input.value) input.select();
  }
}
